<template>
  <div class="app-container">
    <el-form ref="form" :model="form" :rules="rules">
      <BjDivider
        >{{ $t('ProductAuditStrategy.top.SKUreview') }}

        <template #right right-fixed>
          <el-button
            v-permission:SettingGoodsAuditStrategyIndex_Save
            type="primary"
            :loading="loading"
            @click="confirm"
          >
            {{ loading ? $t('savingText') : $t('saveText') }}
          </el-button>
        </template>
      </BjDivider>
      <el-form-item :label="$t('ProductAuditStrategy.top.Create')">
        <el-switch
          v-model="form.createdAuditStatus"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
      <el-form-item :label="$t('ProductAuditStrategy.top.Modify')">
        <el-switch
          v-model="form.updateAuditStatus"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
      <el-form-item v-show="form.updateAuditStatus" :label="$t('ProductAuditStrategy.top.Trigger')" style="margin-left: 15px">
        <el-checkbox
          v-model="form.updatePriceStatus"
          :label="$t('ProductAuditStrategy.top.price')"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
        <el-checkbox
          v-model="form.updatePropertyStatus"
          :label="$t('ProductAuditStrategy.top.attribute')"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
      </el-form-item>
      <BjDivider>{{ $t('ProductAuditStrategy.middle.synchronization') }}</BjDivider>

      <el-form-item :label="$t('ProductAuditStrategy.middle.information')">
        <el-switch
          v-model="form.uploadSkuThirdStatus"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>

      <el-form-item :label="$t('ProductAuditStrategy.middle.classification')">
        <el-switch
          v-model="form.uploadCategoryThirdStatus"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>

      <BjDivider>{{ $t('ProductAuditStrategy.bottom.shelf') }}</BjDivider>
      <!-- TODO:未接入数据 -->
      <el-form-item :label="$t('ProductAuditStrategy.bottom.Open')"
        ><el-switch v-model="form.todo" disabled></el-switch
      ></el-form-item>
    </el-form>
  </div>
</template>

<script>
import { goodsApi } from '@/api';
export default {
  name: 'SettingGoodsAuditStrategyIndex',
  data() {
    return {
      form: {
        _innerMap: {},
        categoryUploadFlag: 0,
        createdAuditStatus: 0,
        id: null,
        updateAuditStatus: 0,
        updatePriceStatus: 0,
        updatePropertyStatus: 0,
        uploadCategoryThirdStatus: 0,
        uploadSkuThirdStatus: 0,
      },
      rules: {},
      loading: false,
    };
  },
  watch: {
    'form.uploadSkuThirdStatus': {
      handler(v) {
        if (v) this.form.uploadCategoryThirdStatus = v;
      },
    },
  },
  created() {
    this.getData();
  },
  methods: {
    /** 获取数据 */
    getData() {
      goodsApi
        .getSkuAudit()
        .then(res => {
          this.form = res;
        });
    },
    /** 保存 */
    confirm() {
      if (
        this.form.updateAuditStatus &&
        !this.form.updatePriceStatus &&
        !this.form.updatePropertyStatus
      ) {
        this.$alert(this.$t('ProductAuditStrategy.bottom.select'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          type: 'error',
          callback: action => {},
        });
      } else {
        this.$confirm(this.$t('ProductAuditStrategy.bottom.Whether'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
        })
          .then(() => {
            this.loading = true;
            goodsApi
              .updateSkuAudit(this.form)
              .then(res => {
                this.loading = false;
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.form = res;
                }, 500);
              }).catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.app-container {
  padding-left: 24px;
}
</style>
